module.exports = __webpack_public_path__ + "static/media/sz.334343c6.svg";